import styled from "styled-components"
import { colors } from "./base"

export const MainContainer = styled.main`
  // padding: 60px;
  width: 100vw;
  height: 100vh;
  flex: 4;
  //transition: all 2s;
  display: flex;
  flex-direction: column;
  overflow: auto;
  //text-transform: uppercase;
  background: ${colors.mainSecondaryBackground};
  font-family: Nunito, sans-serif;

  @media only screen and (max-width: 950px) {
    //transition: all 2s;
    min-width: 100vw;
    min-height: 100vh;
    display: flex;
  }
`

export const PageHeader = styled.h1`
  font-size: 32px;
  font-family: Pacifico, sans-serif;
  color: ${colors.white};
  // font-family: "PT Sans Narrow", "Fjalla One", sans-serif;
  font-weight: 900;
  text-shadow: 1px 1px 2px ${colors.sideNavBackground},
    2px 2px 0 ${colors.headerTextShadow}, 3px 3px 0 ${colors.headerTextShadow},
    4px 4px 0 ${colors.headerTextShadow}, 5px 5px 0 ${colors.headerTextShadow};
  padding: 0px 40px;
  margin-bottom: 10px;
  margin-top: 40px;
`

export const MainHeaderWrapper = styled.section`
  min-height: 250px;
  margin-top: 0;
  background: ${colors.pageHeader};
  border-bottom: 3px solid ${colors.headerBorder};
`

export const MainBodyWrapper = styled.section`
  margin: -100px 40px 20px 40px;
  @media only screen and (max-width: 950px) {
    margin: -100px 20px 20px 20px;
  }
`

export const PageTagLine = styled.p`
  padding-left: 40px;
  color: ${colors.headerTagLine};
`

export const BlogContainer = styled.div`
  display: flex;
  flex-flow: row wrap;
  justify-content: center;
  position: relative;
  z-index: 1;
  max-width: 1004px;
  margin: 20px auto;
  padding: 0;
`

export const PageWrapper = styled.div`
  display: flex;
`

export const PageContainer = styled.div`
  display: flex;
  min-height: 245px;
  // min-width: 100%;
  width: 55vw;
  background: white;
  flex-grow: 1;
  flex-direction: column;
  margin: 0 0px 10px 0px;
  border-radius: 6px;
  padding: 30px 60px 30px 45px;
  overflow: hidden;
  background-color: ${colors.pageBackground};
  box-shadow: 0 1px 4px 0 ${colors.pageShadow};
  //transition: all 0.15s ease-in-out;
  text-align: justify;
  color: ${colors.pageText};

  a {
    color: ${colors.pageHeader};
    // padding: 2px 2px 2px 2px;
  }
  a:hover {
    text-decoration: none;
    color: white;
    background: ${colors.pageHeader};
    // padding: 2px 2px 2px 2px;
    border-radius: 2px;
  }

  img {
    max-height: 250px;
    max-width: 250px;
    float: right;
    margin-left: 20px;
    border-radius: 4px;
    box-shadow: 0 1px 3px 0 ${colors.pageShadow};

    @media only screen and (max-width: 950px) {
      margin-right: -12px;
      margin-top: 20px;
      margin-bottom: 20px;
      display: none;
    }
  }

  p {
    margin-top: 10px;
    margin-bottom: 10px;
  }

  pre {
    max-width: 650px;
    background: ${colors.codeBackground};
    border: 2px ${colors.headerBorder} solid;
    box-shadow: 0 1px 4px 0 ${colors.pageShadow};
  }
    
  }

  @media only screen and (max-width: 950px) {
    padding: 30px 25px 30px 25px;
  }

  
}

  figure {
    display: flex;
    flex-direction: column;
    height: 300px;
    margin-left: -10px;
    align-self: center;
    img {
      border: 2px solid ${colors.pageHeader};
      display: block;
    }
  }
  figcaption {
    color: ${colors.headerTagLine};
    align-self: center;
    font-style: italic;
    font-weight: 300;
    font-size: 16px;
  }
  button {
    background: ${colors.pageHeader}
    //padding: 2px 3px 2px 4px;

    :hover {
      //padding: 0px;
      background: ${colors.headerBorder};
      //padding: 2px 3px 2px 4px;
    }
    
  }
  ul {
    margin: 0px;
    a {
      padding: 0px;
    }
  }
`

export const PostButtons = styled.button`
  background: ${colors.sideNavBackground};
  border-radius: 4px;
  transition: transform 0.15s ease-in-out;
  color: ${colors.white};

  :hover {
    background: ${colors.homeBackground};
    color: ${colors.sideNavBackground};
    cursor: pointer;
    box-shadow: 0 1px 7px rgba(0, 0, 0, 0.1);
    transform: scale(1.05, 1.05);
    cursor: pointer;
  }
`

export const MainRightSidebar = styled.section`
  background: ${colors.white};
  width: 300px;
  margin-left: 20px;
  border-radius: 4px;
  height: 240px;
  position: sticky;
  top: 10px;
  box-shadow: 0 1px 4px 0 rgba(0, 0, 0, 0.37);
  display: flex;
  align-items: center;
  justify-content: flex-end;
  flex-direction: column;
  justify-content: center;
  padding: 8px;

  > img {
    width: 120px;
  }
  @media only screen and (max-width: 950px) {
    display: none;
  }
`

export const BuyButton = styled.button`
  background: ${colors.pageHeader};
  color: ${colors.white};
  border-radius: 4px;
  font-size: 14px;
  width: 160px;
  text-align: center;
  display: flex;
  justify-content: space-evenly;
  align-items: center;
  padding: 6px;
  transition: transform 0.15s ease-in-out;

  > img {
    margin-bottom: 0px;
    height: 30px;
  }
  :hover {
    cursor: pointer;
    transform: scale(1.05, 1.05);
    box-shadow: 0 1px 7px rgba(0, 0, 0, 0.1);
  }
`

{
  /* <style>.bmc-button img{width: 35px !important;margin-bottom: 1px !important;box-shadow: none !important;border: none !important;vertical-align: middle !important;}.bmc-button{padding: 7px 5px 7px 10px !important;line-height: 35px !important;height:51px !important;min-width:217px !important;text-decoration: none !important;display:inline-flex !important;color:#FFFFFF !important;background-color:#FF813F !important;border-radius: 5px !important;border: 1px solid transparent !important;padding: 7px 5px 7px 10px !important;font-size: 22px !important;letter-spacing: 0.6px !important;box-shadow: 0px 1px 2px rgba(190, 190, 190, 0.5) !important;-webkit-box-shadow: 0px 1px 2px 2px rgba(190, 190, 190, 0.5) !important;margin: 0 auto !important;font-family:'Cookie', cursive !important;-webkit-box-sizing: border-box !important;box-sizing: border-box !important;-o-transition: 0.3s all linear !important;-webkit-transition: 0.3s all linear !important;-moz-transition: 0.3s all linear !important;-ms-transition: 0.3s all linear !important;transition: 0.3s all linear !important;}.bmc-button:hover, .bmc-button:active, .bmc-button:focus {-webkit-box-shadow: 0px 1px 2px 2px rgba(190, 190, 190, 0.5) !important;text-decoration: none !important;box-shadow: 0px 1px 2px 2px rgba(190, 190, 190, 0.5) !important;opacity: 0.85 !important;color:#FFFFFF !important;}</style><link href="https://fonts.googleapis.com/css?family=Cookie" rel="stylesheet"><a class="bmc-button" target="_blank" href="https://www.buymeacoffee.com/sagarhani"><img src="https://cdn.buymeacoffee.com/buttons/bmc-new-btn-logo.svg" alt="Buy me a coffee"><span style="margin-left:15px;font-size:28px !important;">Buy me a coffee</span></a> */
}
